import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ValidatableField from './ValidatableField';

import './TextArrayField.css';

const SEPERATOR = ',';

function decodeValue(value) {
  if (value && value.length > 0) {
    const list = value.split(SEPERATOR);
    if (list[list.length - 1].length > 0) {
      list.push('');
    }
    return list;
  }
  return [''];
}

function encodeValue(value) {
  if (value && value.length > 0) {
    return value
      .filter(item => item && item.length > 0)
      .join(SEPERATOR);
  }
  return '';
}

class TextArrayFieldComponent extends ValidatableField {
  constructor(props) {
    super(props);
    this.state.value = decodeValue(props.value);
  }

  static get propTypes() {
    return {
      label: PropTypes.string,
      value: PropTypes.any,
      editing: PropTypes.bool,
      name: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired,
      required: PropTypes.bool,
      validationMessage: PropTypes.string
    };
  }

  static get defaultProps() {
    return {
      value: '',
      validationMessage: 'Please enter valid values without commas'
    };
  }

  componentWillReceiveProps(props) {
    if (this.props.value !== props.value) {
      this.setState({
        value: decodeValue(props.value)
      }, () => this.validate());
    }
  }

  validate() {
    const { required } = this.props;
    const { value } = this.state;

    const hasValue = value.length > 0 && value[0].length > 0;
    const valid = !required || hasValue;

    this.setValid(valid);
    return valid;
  }

  showLabel() {
    const { editing } = this.props;
    const { value } = this.state;
    return !editing || value.length > 1;
  }

  onChange(index, item) {
    const { value } = this.state;

    const newValue = [].concat(value);
    newValue[index] = item;

    if (newValue[newValue.length - 1].length > 0) {
      newValue.push('');
    }

    this.setState({
      value: newValue
    });
  }

  onBlur() {
    const { onChange } = this.props;
    const { value } = this.state;

    if (this.validate()) {
      onChange(encodeValue(value));
    }
  }

  renderControl() {
    const { editing, name, className, label, required } = this.props;
    const placeholder = `${label} ${required ? '' : '(optional)'}`;
    const { value } = this.state;

    return value.map((item, index) =>
      (<input
        type="text"
        key={this.key(index)}
        placeholder={(editing && index === 0 && value.length <= 1) ? placeholder : ''}
        className={classnames(className, 'TextArrayField', `textarray-${name}`, { 'is-disabled': !editing })}
        value={item}
        onChange={event => this.onChange(index, event.target.value)}
        onBlur={() => this.onBlur()}
        disabled={!editing}
      />)
    );
  }

  key(index) {
    return `val-${index}`;
  }
}

export default TextArrayFieldComponent;



// WEBPACK FOOTER //
// ./src/recordDetail/fields/TextArrayField.js